export type Compile = {
	watch: any
};